import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, fromEvent, merge } from 'rxjs';

import { AuthUser } from '../../../../core/auth/auth-frame/auth-user.model';
import { AuthService } from '../../../../core/auth/auth.service';
import { MenuCategory } from '../../../menu/menu-category.model';
import { MenuSubMenu } from '../../../menu/menu-sub-menu.model';
import { Menu } from '../../../menu/menu.model';
import { MenuService } from '../menu.service';
import { ItauUserIdleService } from '@app/core/security/itau-user-idle.service';
import { SessionService } from '@app/core/session/session.service';
import { FullMenuService } from '@app/full-menu/full-menu.service';

import { LogParams } from './log-users/log-users.interface';
import { Router } from '@angular/router';
import { FeatureToggleService } from '@app/shared/feature-toggle/feature.toggle.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { detailFromBreadcrumb, normalizePath, normalizePathFromBreadcrumb, slugify } from '@app/shared/utils';

@Component({
  selector: "app-menu-category-option",
  templateUrl: "./menu-category-option.component.html",
  styleUrls: ["./menu-category-option.component.css"],
})
export class MenuCategoryOptionComponent implements OnInit {
  @Input() option: MenuCategory;
  @Input() menu: string;
  @Input() isLast: boolean;
  @Input() category: Menu;
  @Output() showAllOptions: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() clickHideMenu: EventEmitter<string> = new EventEmitter<string>();
  @Input() initialIndex: number;

  public authUser: AuthUser;
  authSubject: Observable<AuthUser>;

  constructor(
    public translate: TranslateService = null,
    private menuService: MenuService,
    private authService: AuthService,
    @Inject("Window") private _window: Window,
    private itauUserIdleService: ItauUserIdleService,
    private sessionService: SessionService,
    private fullMenuService: FullMenuService,
    private router: Router,
    private featureToggleService: FeatureToggleService,
    private _sdkAnalyticsService: SdkAnalyticsService
  ) { }

  ngOnInit() {
    this.authSubject = this.authService.getAuthModel();
    this.authSubject.subscribe((user: AuthUser) => {
      this.authUser = user;
    });
  }

  get name(): string {
    if (!this.option) return "";

    return this.option.name;
  }

  get translationKey(): string {
    if (!this.option) return "";

    return this.option.translationKey + ".TRANSLATION";
  }

  get subOptions(): Array<MenuSubMenu> {
    if (!this.hasSubOptions) return [];

    let filteredList = this.option.subMenus.filter((item, index) => index < 5);

    return filteredList;
  }

  get hasOptions(): boolean {
    return !!this.option;
  }

  get hasSubOptions(): boolean {
    if (!this.option) return false;
    if (!this.option.subMenus) return false;

    return true;
  }

  get hasManySubOptions(): boolean {
    if (!this.hasSubOptions) return false;
    if (this.option.subMenus.length <= 5) return false;
    return true;
  }

  openFullMenu() {
    this.showAllOptions.emit(true);
    this.fullMenuService.setSelectedTranslationKeyCategory(
      this.option.translationKey
    );
    this.menuService.fullMenu(
      this.translate.currentLang,
      this.category.name.toLowerCase(),
      this.name,
      new Date().getTime()
    );
  }

  paramsModel(user: any): LogParams {
    return {
      sessao: user.token,
      id: user.idSessao,
      idsessao: user.idConexao,
      gestor: user.gestor,
      nomeUsu: user.name,
      iDFuncao: user.tipo,
    };
  }

  openModal(context) {//(codFunction, name, url) {
    const codFunction = context.id;
    const name = context.name;
    const url = context.url;
    if (context.path && this.router && this.router.url) {
      this._sdkAnalyticsService.trackEvent('click', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: detailFromBreadcrumb(context.path)
      });
    }

    if (/IS\/#/.test(url)) {
      this.router.navigate([`${url.split('/#')[1]}`]);
      return false;
    }

    var sUrl = this.authUser.serverEstatisticas + "?xyz=0";

    try {
      this.itauUserIdleService.stopWatching();
      this.sessionService.updateSession().subscribe(() => { });
      let userType = this.authUser.tipo == 1 ? "A" : "C";
      sUrl += this.getQueryString(
        this.authUser.token,
        this.authUser.idSessao,
        this.authUser.idConexao,
        this.authUser.gestor,
        this.authUser.name,
        userType
      );
      sUrl += this.getQueryStringFunction(codFunction);
      var windowOK4 = this._window.open(
        sUrl,
        name,
        "directories=no,resizable=1,location=no,scrollbars=yes,height=560,width=790,left=5,top=5"
      );
      this._sdkAnalyticsService.trackEvent('screen_view', {
        custom_path: normalizePathFromBreadcrumb(context.path, { prefix: '/iss/lg/' }),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: detailFromBreadcrumb(context.path)
      });

      this.itauUserIdleService.setCustomActivityEvents(
        merge(
          fromEvent(window, "mousemove"),
          fromEvent(window, "resize"),
          fromEvent(document, "keydown"),
          fromEvent(document, "touchstart"),
          fromEvent(document, "touchend"),
          fromEvent(windowOK4, "mousemove"),
          fromEvent(windowOK4, "resize")
        )
      );
      this.itauUserIdleService.startWatching();
    } catch (ex) {
      throw ex;
    }
  }

  openModalContext(context) {
    if (context.path && this.router && this.router.url) {
      this._sdkAnalyticsService.trackEvent('click', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: detailFromBreadcrumb(context.path)
      });
    }
    this.menuService.openContext(context.url);
    this.clickHideMenu.emit(context.url);
  }

  private getQueryStringFunction(codFunction) {
    try {
      return "&iDFuncao=" + -1 * codFunction;
    } catch (ex) {
      throw ex;
    }
  }

  private getQueryString(
    token,
    idConnection,
    idSession,
    sGestor,
    nameUser,
    userType
  ) {
    try {
      return (
        "&sessao=" +
        token +
        "&id=" +
        idConnection +
        "&idsessao=" +
        idSession +
        "&gestor=" +
        sGestor +
        "&nomeUsu=" +
        nameUser +
        "&tipousu=" +
        userType
      );
    } catch (ex) {
      throw ex;
    }
  }

  submitEvent(pageName: string) {
  }

  goToiServices(url?: string) {
    if (this.router && this.router.url) {
      this._sdkAnalyticsService.trackEvent('click', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: 'menu-iservices'
      });
    }

    this.featureToggleService.goToiServices(url);
  }
}
